<template>
    <div class="w-full flex items-center gap-1 mb-4 mt-2">
        <span v-for="i in 5" :key="i" class="bg-gray-500 rounded-md w-6 h-6"
            :class="{ 'bg-green-500': i <= rating }">&nbsp;</span>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        rating: {
            type: Number,
            required: true,
        },
    },
};
</script>
